import { useId } from "react";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import OutlinedInput, { type OutlinedInputProps } from "@mui/material/OutlinedInput";

/**
 * A static bold label above a white outlined input, matching the SSO
 * reference (docs/design/reference/sso-login-reference.png): a plain
 * FormLabel, not MUI's default floating/notched label. `notched={false}`
 * removes the outline notch that a floating label would otherwise cut.
 */
export function LabeledTextField({
  label,
  id,
  ...inputProps
}: OutlinedInputProps & { label: string }) {
  const generatedId = useId();
  const fieldId = id ?? generatedId;

  return (
    <FormControl fullWidth={inputProps.fullWidth ?? true} error={inputProps.error} variant="outlined">
      <FormLabel htmlFor={fieldId}>{label}</FormLabel>
      <OutlinedInput {...inputProps} id={fieldId} notched={false} />
    </FormControl>
  );
}
